// Copyright (C) 2021 Bystronic Laser AG

export enum BendTrendMode {
  Chronological = 'chronological',
  Seasonal = 'seasonal',
  Comparative = 'comparative',
}
